import { createFileRoute } from "@tanstack/react-router";

const TERMS_TITLE = "Terms of Service | Glider";
const TERMS_DESCRIPTION =
  "The terms that govern access to Glider's website and the Glider Platform.";

export const Route = createFileRoute("/terms")({
  head: () => ({
    meta: [
      { title: TERMS_TITLE },
      { content: TERMS_DESCRIPTION, name: "description" },
      { content: TERMS_TITLE, property: "og:title" },
      { content: TERMS_DESCRIPTION, property: "og:description" },
      { content: "website", property: "og:type" },
      { content: "summary", name: "twitter:card" },
      { content: TERMS_TITLE, name: "twitter:title" },
      { content: TERMS_DESCRIPTION, name: "twitter:description" },
    ],
  }),
});
